import React, { useEffect, useMemo, useState } from "react";
import { getInitials } from "../../utils/helpers/getInitials";
import { resolveAssetUrl } from "../../utils/helpers/storeSetting";
import "./style.css";

const ItemAvatar = ({
  name = "Item",
  image,
  imageUrl,
  size = "md",
  className = "",
  rounded = true,
}) => {
  const source = useMemo(() => resolveAssetUrl(imageUrl || image, ""), [image, imageUrl]);
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [source]);

  const hasImage = Boolean(source) && !failed;

  return (
    <span
      className={`akas-item-avatar akas-item-avatar-${size}${rounded ? " is-rounded" : ""}${hasImage ? " has-image" : " is-fallback"} ${className}`.trim()}
      title={name}
      aria-label={hasImage ? `Gambar ${name}` : `Inisial ${name}`}>
      {hasImage ? (
        <img
          src={source}
          alt={name}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <span aria-hidden="true">{getInitials(name || "Item") || "I"}</span>
      )}
    </span>
  );
};

export default ItemAvatar;
